import React from 'react'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

const Description = (): JSX.Element => {
  return (
    <Typography tag="p">
      <Typo>
        View and manage your pension transfers. Here you can track transfers you've already submitted, including
        transfer amounts and dates. If you need to update a transfer or have any questions, please contact our team for
        help.
      </Typo>
    </Typography>
  )
}

export { Description }
